import { createIconComponent } from '../../factory/create-icon-component';
export const MoneyIcon = createIconComponent(
  'MoneyIcon',
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7 4.25C7 5.64782 7 6.34674 6.77164 6.89805C6.46716 7.63313 5.88313 8.21716 5.14805 8.52164C4.59674 8.75 3.89782 8.75 2.5 8.75M17 4.25C17 5.64782 17 6.34674 17.2284 6.89805C17.5328 7.63313 18.1169 8.21716 18.8519 8.52164C19.4033 8.75 20.1022 8.75 21.5 8.75M17 19.25C17 17.8522 17 17.1533 17.2284 16.6019C17.5328 15.8669 18.1169 15.2828 18.8519 14.9784C19.4033 14.75 20.1022 14.75 21.5 14.75M7 19.25C7 17.8522 7 17.1533 6.77164 16.6019C6.46716 15.8669 5.88313 15.2828 5.14805 14.9784C4.59674 14.75 3.89782 14.75 2.5 14.75M2 13.35V10.15C2 7.90979 2 6.78969 2.43597 5.93404C2.81947 5.18139 3.43139 4.56947 4.18404 4.18597C5.03969 3.75 6.15979 3.75 8.4 3.75H10H14H15.6C17.8402 3.75 18.9603 3.75 19.816 4.18597C20.5686 4.56947 21.1805 5.18139 21.564 5.93404C22 6.78969 22 7.90979 22 10.15V13.35C22 15.5902 22 16.7103 21.564 17.566C21.1805 18.3186 20.5686 18.9305 19.816 19.314C18.9603 19.75 17.8402 19.75 15.6 19.75H8.4C6.15979 19.75 5.03969 19.75 4.18404 19.314C3.43139 18.9305 2.81947 18.3186 2.43597 17.566C2 16.7103 2 15.5902 2 13.35Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <circle
      cx="12"
      cy="12"
      r="2"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>,
);
